// extracted by mini-css-extract-plugin
export var closeButton = "_j0-1";
export var closeX = "_j0-3";
export var container = "_j0-0";
export var image = "_j0-2";